'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPillWrapper = exports.SelectPillScroller = exports.SelectPillIcon = exports.SelectPill = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: translateX(-5%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateX(-5%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  animation-duration: .3s;\n  background-color: ', ';\n  border-radius: 4px;\n  border: 1px solid;\n  color: ', ';\n  cursor: default;\n  flex-shrink: 0;\n  line-height: 1;\n  margin-right: 4px;\n  padding: 6px 8px;\n'], ['\n  animation-name: ', ';\n  animation-duration: .3s;\n  background-color: ', ';\n  border-radius: 4px;\n  border: 1px solid;\n  color: ', ';\n  cursor: default;\n  flex-shrink: 0;\n  line-height: 1;\n  margin-right: 4px;\n  padding: 6px 8px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  opacity: 1;\n  transition: opacity .3s;\n\n  &:hover {\n    opacity: 0.6;\n  }\n'], ['\n  opacity: 1;\n  transition: opacity .3s;\n\n  &:hover {\n    opacity: 0.6;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-overflow-scrolling: touch;\n'], ['\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-overflow-scrolling: touch;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: nowrap;\n'], ['\n  display: flex;\n  flex-wrap: nowrap;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var animateIn = (0, _styledComponents.keyframes)(_templateObject);

var SelectPill = exports.SelectPill = _styledComponents2.default.div(_templateObject2, animateIn, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.white;
});

SelectPill.displayName = 'SelectPill';
var SelectPillIcon = exports.SelectPillIcon = (0, _styledComponents2.default)(_nitroIcon2.default)(_templateObject3);

SelectPillIcon.displayName = 'SelectPillIcon';
var SelectPillScroller = exports.SelectPillScroller = _styledComponents2.default.div(_templateObject4);

SelectPillScroller.displayName = 'SelectPillScroller';
var SelectPillWrapper = exports.SelectPillWrapper = _styledComponents2.default.div(_templateObject5);
SelectPillWrapper.displayName = 'SelectPillWrapper';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-multiple-select/styles.js
// module id = 3019
// module chunks = 4